import { ReactElement } from 'react';
import { DocumentationViewItem, isDirectoryItemType } from 'store/documentation/model/types';
import { CurrentVersionNumber } from 'components/documentation/CurrentVersionNumber';

interface Props {
  rowData: DocumentationViewItem;
  value: number | null | undefined;
}

export function DocumentationCurrentVersionCell({ rowData, value }: Props): ReactElement | null {
  if (isDirectoryItemType(rowData.type)) {
    return null;
  }
  return <CurrentVersionNumber number={value} />;
}
